module.exports = __webpack_public_path__ + "static/media/fa-light-300.72153f18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/webfonts/fa-light-300.svg
// module id = 876
// module chunks = 0